import { useContext, useEffect, useRef, useState } from "react";
import logo from "../assets/website-logo-white.svg";
import Modal from "./modal";
import GuidedTour from "./guidedTour";
import {
  FaCaretDown,
  FaCanadianMapleLeaf,
  FaShoppingCart,
} from "react-icons/fa";
import faq from "../content/faq.json";
import Faq from "react-faq-component";
import { getDatabase, ref, push, child, update } from "firebase/database";
import {
  fetchTemplateFromFirebase,
  getCartTotalAmount,
  notify,
} from "../util/helpers";
import axios from "axios";
import AppContext from "../context";
import tutorial1 from "../assets/videos/tutorial.webm";
import tutorial2 from "../assets/videos/measuring.webm";
import variables from "../styles/export.module.scss";
import blackFelt from "../assets/materials/black-felt.webp";
import blueFelt from "../assets/materials/blue-felt.webp";
import greenFelt from "../assets/materials/green-felt.webp";
import redFelt from "../assets/materials/red-felt.webp";
import anthraciteNonSkid from "../assets/materials/anthracite.webp";
import blackNonSkid from "../assets/materials/black.webp";
import blueJadeNonSkid from "../assets/materials/blue-jade.webp";
import brownNonSkid from "../assets/materials/brown.webp";
import grayNonSkid from "../assets/materials/gray.webp";
import pruneNonSkid from "../assets/materials/prune.webp";
import greenNonSkid from "../assets/materials/sage-green.webp";
import taupeNonSkid from "../assets/materials/taupe.webp";
import walnutWood from "../assets/materials/walnut.webp";
import cedarWood from "../assets/materials/cedar.webp";
import whiteOakWood from "../assets/materials/white-oak.webp";
import mapleWood from "../assets/materials/maple.webp";
import { readableColor } from "color2k";
import { templateMapper } from "../content/templates";
import { db } from "../firebase";
import Loader from "./loader";

const Header = () => {
  const {
    handleSetShoppingCartModal,
    cart,
    handleSetGlobalModal,
    triggerPriceUpdate,
    triggerDimensionsUpdate,
  } = useContext(AppContext);
  const [loadModal, setLoadModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [aboutModal, setAboutModal] = useState(false);
  const [shippingModal, setShippingModal] = useState(false);
  const [galleryModal, setGalleryModal] = useState(false);
  const [contactModal, setContactModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmTemplateModal, setConfirmTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templatesDropdownActive, setTemplatesDropdownActive] = useState(false);
  const [tutorialsDropdownActive, setTutorialsDropdownActive] = useState(false);
  const [shareInsertModal, setShareInsertModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [shareKey, setShareKey] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [selectedWidthCategory, setSelectedWidthCategory] = useState(null);
  const [templatesModalOpen, setTemplatesModalOpen] = useState(false);
  const templatesDropdownTriggerRef = useRef(null);
  const tutorialsDropdownTriggerRef = useRef(null);

  const feltImages = [
    { name: "Red", src: redFelt },
    { name: "Black", src: blackFelt },
    { name: "Green", src: greenFelt },
    { name: "Blue", src: blueFelt },
  ];

  const nonSkidImages = [
    { name: "Anthracite", src: anthraciteNonSkid },
    { name: "Black", src: blackNonSkid },
    { name: "Blue Jade", src: blueJadeNonSkid },
    { name: "Brown", src: brownNonSkid },
    { name: "Gray", src: grayNonSkid },
    { name: "Prune", src: pruneNonSkid },
    { name: "Green", src: greenNonSkid },
    { name: "Taupe", src: taupeNonSkid },
  ];

  const woodImages = [
    { name: "Walnut", src: walnutWood },
    { name: "Cedar", src: cedarWood },
    { name: "White Oak", src: whiteOakWood },
    { name: "Maple", src: mapleWood },
  ];

  const tutorials = [
    {
      video: tutorial1,
      name: "Using the Drawer Insert Designer",
      description:
        "Learn how to use the Drawer Insert Designer to design and order your custom drawer inserts.",
    },
    {
      video: tutorial2,
      name: "Measuring Guidelines",
      description:
        "This video demonstrates step-by-step how you can measure your drawer for a custom drawer insert.",
    },
  ];

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        templatesDropdownTriggerRef.current &&
        !templatesDropdownTriggerRef.current.contains(event.target)
      )
        setTemplatesDropdownActive(false);
    };
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [templatesDropdownTriggerRef.current]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        tutorialsDropdownTriggerRef.current &&
        !tutorialsDropdownTriggerRef.current.contains(event.target)
      )
        setTutorialsDropdownActive(false);
    };
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [tutorialsDropdownTriggerRef.current]);

  const styles = {
    // bgColor: 'white',
    rowTitleColor: "#blue",
    // rowContentColor: 'grey',
    arrowColor: variables.primaryColor,
  };

  const saveSharedInsert = async () => {
    try {
      const insertJson = window?.saveInsert?.(true);
      const compressedJson = await axios.post(
        "/.netlify/functions/insert/gzip",
        insertJson
      );
      const newShareKey = push(child(ref(db), "shared")).key;
      setShareKey(newShareKey);
      const updates = {};
      updates["/shared/" + newShareKey] = compressedJson.data;
      update(ref(db), updates);
    } catch (error) {}
  };

  const handleTemplateSelect = async (storageLocation) => {
    // Close template modal
    setTemplatesModalOpen(false);
    // Initialize designer with the selected template
    //handleSetCurrentInsertDimensions(currentDimensions);
    setLoading(true);
    // Load the template from Firebase
    const template = await fetchTemplateFromFirebase(storageLocation);

    if (template.error) {
      return;
    } else if (window?.loadInsert) {
      window.loadInsert(JSON.stringify(template));
    }
    setTimeout(() => {
      setLoading(false);
      triggerPriceUpdate();
      triggerDimensionsUpdate();
      notify("Template loaded!");
    }, 250);
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true,
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: "100",
            backgroundColor: "rgba(255,255,255,0.8)",
          }}
        >
          <Loader />
        </div>
      )}
      <header
        style={{
          color: readableColor(variables.accentColor),
          backgroundColor: variables.accentColor,
        }}
        className="did-header"
      >
        <nav
          className="navbar"
          role="navigation"
          aria-label="header navigation"
        >
          <div className="navbar-brand">
            <img
              src={logo}
              alt="Varcroft and Bianco logo"
              className="brand-logo"
            />
            {/* eslint-disable-next-line */}
            {/*             <a
              role="button"
              className={`navbar-burger ${expanded ? "is-active" : ""}`}
              aria-label="menu"
              aria-expanded="false"
              data-target="navbarMenu"
              onClick={() => setExpanded(!expanded)}
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a> */}
          </div>
          <div
            className={`navbar-menu ${expanded ? "is-active" : ""}`}
            id="navbarMenu"
          >
            <div className="navbar-start pl-5 mr-6">
              <div className="navbar-menu__fill-block"></div>
              <h1 className="navbnar-menu__site-header title is-size-3-fullhd is-size-5-tablet ml-6 mb-0 has-text-weight-light is-flex is-align-items-center">
                Drawer Insert Designer 2.1
              </h1>
              <div className="navbar-start__actions" id="tutorialTemplates">
                <div
                  className={`content-dropdown dropdown ${
                    tutorialsDropdownActive ? "is-active" : ""
                  }`}
                >
                  <div className="dropdown-trigger">
                    <button
                      className="button is-outlined ml-2 mt-1"
                      aria-haspopup="true"
                      style={{
                        color: readableColor(variables.accentColor),
                        borderColor: readableColor(variables.accentColor),
                      }}
                      aria-controls="templates-menu"
                      onClick={() => {
                        setTutorialsDropdownActive(!tutorialsDropdownActive);
                      }}
                      ref={tutorialsDropdownTriggerRef}
                    >
                      Tutorial
                    </button>
                  </div>
                  <div
                    className="dropdown-menu"
                    id="tutorials-menu"
                    role="menu"
                  >
                    <div className="dropdown-content pt-0 pb-0">
                      {tutorials.map((tutorial, index) => {
                        return (
                          <div key={tutorial.video}>
                            {tutorials.length > 1 && index > 0 && (
                              <hr className="dropdown-divider" />
                            )}
                            <div
                              className="template-dropdown-item is-clickable"
                              role="button"
                              onClick={() => {
                                handleSetGlobalModal(
                                  <div style={{ minWidth: "100%" }}>
                                    <video controls autoPlay>
                                      <source src={tutorial.video} />
                                    </video>
                                  </div>,
                                  {
                                    wide: true,
                                    pronouncedCloseButton: true,
                                  }
                                );
                              }}
                            >
                              <figure className="template-dropdown-item--image mr-2">
                                <img
                                  src={
                                    require(`../assets/video-thumbnail.png`)
                                      .default
                                  }
                                  alt=""
                                />
                              </figure>
                              <div className="is-flex is-flex-direction-column is-align-items-flex-start">
                                <p className="is-size-6 has-text-dark mb-2 is-size-6">
                                  {tutorial.name}
                                </p>
                                <p className="has-text-grey is-size-7">
                                  {tutorial.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div
                  className={`content-dropdown dropdown ${
                    templatesDropdownActive ? "is-active" : ""
                  }`}
                >
                  <div className="dropdown-trigger">
                    <button
                      className="button is-outlined ml-2 mt-1"
                      style={{
                        color: readableColor(variables.accentColor),
                        borderColor: readableColor(variables.accentColor),
                      }}
                      aria-haspopup="true"
                      aria-controls="templates-menu"
                      onClick={() => {
                        setTemplatesDropdownActive(!templatesDropdownActive);
                      }}
                      ref={templatesDropdownTriggerRef}
                    >
                      Templates
                    </button>
                  </div>
                  <div
                    className="dropdown-menu"
                    id="templates-menu"
                    role="menu"
                  >
                    <div className="dropdown-content pt-0 pb-0">
                      {Object.keys(templateMapper).map((key, index) => (
                        <div key={key}>
                          {Object.keys(templateMapper).length > 1 &&
                            index > 0 && (
                              <hr className="dropdown-divider my-0" />
                            )}
                          <div
                            className="template-dropdown-item is-clickable py-3 px-3"
                            role="button"
                            onClick={() => {
                              setSelectedWidthCategory(key);
                              setTemplatesModalOpen(!templatesModalOpen);
                              setTemplatesDropdownActive(false);
                            }}
                          >
                            <div className="is-flex is-flex-direction-column is-align-items-flex-start">
                              <p className="is-size-6 has-text-dark is-size-6">
                                {templateMapper[key].name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="vertical"></hr>
            <div className="pl-4 navbar-end is-flex is-align-items-center pr-5">
              <div className="dropdown is-hoverable">
                <div className="dropdown-trigger" id="fileOptions">
                  <button
                    className="button is-light"
                    style={{
                      color: readableColor(variables.accentColor),
                    }}
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                  >
                    <span>File</span>
                    <span className="icon is-small">
                      <FaCaretDown></FaCaretDown>
                    </span>
                  </button>
                </div>
                <div className="dropdown-menu" id="dropdown-menu" role="menu">
                  <div className="dropdown-content">
                    <a
                      className="dropdown-item"
                      onClick={() => setSaveModal(!saveModal)}
                    >
                      Save
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => setLoadModal(!loadModal)}
                    >
                      Open
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => window?.printInsert?.()}
                    >
                      Print
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => setShareInsertModal(!shareInsertModal)}
                    >
                      Share
                    </a>
                  </div>
                </div>
              </div>
              <div className="dropdown is-hoverable">
                <div className="dropdown-trigger" id="moreOptions">
                  <button
                    className="button is-light"
                    style={{
                      color: readableColor(variables.accentColor),
                    }}
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                  >
                    <span>More</span>
                    <span className="icon is-small">
                      <FaCaretDown></FaCaretDown>
                    </span>
                  </button>
                </div>
                <div className="dropdown-menu" id="dropdown-menu" role="menu">
                  <div className="dropdown-content">
                    <a
                      className="dropdown-item"
                      onClick={() => setGalleryModal(!galleryModal)}
                    >
                      Materials
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => setShippingModal(!shippingModal)}
                    >
                      Shipping
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => setContactModal(!contactModal)}
                    >
                      Contact
                    </a>
                    <div className="dropdown-item">
                      <button
                        className="reset-button"
                        aria-haspopup="true"
                        onClick={() => {
                          localStorage.removeItem("skipDrawerInsertTour");
                          setShowTour(true);
                        }}
                      >
                        Guided Tour
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/*               <button
                className="button is-light is-size-5 shopping-cart-button"
                style={{
                  color: readableColor(variables.accentColor),
                }}
                onClick={() => handleSetShoppingCartModal()}
              >
                {cart && cart.length > 0 && (
                  <div className="shopping-cart-button--quantity">
                    {getCartTotalAmount(cart)}
                  </div>
                )}
                <FaShoppingCart />
              </button> */}
              <button
                className="ml-2 button is-success"
                style={{ minWidth: "unset" }}
                onClick={() => setAboutModal(!aboutModal)}
              >
                ?
              </button>
            </div>
          </div>
          <span
            className="manufacture-origin-tag"
            style={{
              color: readableColor(variables.accentColor),
            }}
          >
            Made in Canada <FaCanadianMapleLeaf />
          </span>
        </nav>
      </header>
      <Modal trigger={loadModal}>
        <div className="common-modal">
          <div className="common-modal__content content">
            <label
              className="is-flex is-flex-direction-column is-align-items-center"
              htmlFor="uploadInput"
              onClick={() => setLoadModal(false)}
            >
              <h2>Load Insert</h2>
              <input
                type="file"
                className="pt-4"
                id="uploadInput"
                name="insertToUpload"
                accept=".json"
                onChange={() =>
                  setTimeout(() => {
                    triggerPriceUpdate();
                    triggerDimensionsUpdate();
                  }, 200)
                }
              />
              <span className="mt-4 button is-primary">
                Select insert file...
              </span>
            </label>
          </div>
        </div>
      </Modal>
      <Modal trigger={saveModal}>
        <div className="common-modal">
          <div className="common-modal__content content">
            <h2>Save Insert</h2>
            <p>File saves to your Downloads folder.</p>
            <div className="field has-addons">
              <div className="control">
                <input
                  className="input mt-4"
                  id="insertName"
                  type="text"
                  defaultValue="my.drawer.insert"
                  placeholder="my.drawer.insert"
                  aria-label="my.drawer.insert"
                />
              </div>
              <div className="control">
                <button
                  className="mt-4 button is-primary"
                  type="button"
                  onClick={() => window?.saveInsert?.()}
                >
                  Save Insert
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal trigger={aboutModal}>
        <div className="common-modal">
          <div className="common-modal__content content">
            <div className="p-6">
              <Faq data={faq} styles={styles} config={config} />
            </div>
          </div>
        </div>
      </Modal>
      <Modal trigger={shippingModal}>
        <div className="common-modal">
          <div className="common-modal__content p-6 content">
            <h2>Shipping</h2>
            <p>
              Inserts are individually packaged and shipped via Canada Post
              and/or the USPS. Usually takes 3-5 business days in Canada and
              5-10 to the US or Internationally. A tracking number will be sent
              to you once the item has been shipped.
            </p>
          </div>
        </div>
      </Modal>
      <Modal trigger={galleryModal} options={{ wide: true }}>
        <div className="common-modal">
          <div
            className="common-modal__content p-6 content"
            style={{
              width: "100%",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              minHeight: "640px",
            }}
          >
            <h2>Materials</h2>
            <details open>
              <summary
                style={{
                  color: readableColor(variables.accentColor),
                }}
              >
                Wood
              </summary>
              <ul className="common-modal__content--image-gallery">
                {woodImages.map(({ src, name }) => (
                  <li key={name}>
                    <img src={src} alt="Insert materials" />
                    <p>{name}</p>
                  </li>
                ))}
              </ul>
            </details>
            <details>
              <summary
                style={{
                  color: readableColor(variables.accentColor),
                }}
              >
                Non-Slip
              </summary>
              <ul className="common-modal__content--image-gallery">
                {nonSkidImages.map(({ src, name }) => (
                  <li key={name}>
                    <img src={src} alt="Insert materials" />
                    <p>{name}</p>
                  </li>
                ))}
              </ul>
            </details>
            <details>
              <summary
                style={{
                  color: readableColor(variables.accentColor),
                }}
              >
                Felt
              </summary>
              <ul className="common-modal__content--image-gallery">
                {feltImages.map(({ src, name }) => (
                  <li key={name}>
                    <img src={src} alt="Insert materials" />
                    <p>{name}</p>
                  </li>
                ))}
              </ul>
            </details>
          </div>
        </div>
      </Modal>
      <Modal trigger={contactModal}>
        <div className="common-modal">
          <div className="common-modal__content p-6 content">
            <h2>Contact information</h2>
            <ul>
              <li>Drawer Insert Designer ℅ Varcroft &#38; Bianco</li>
              <li> 733 County Road 8 Douro Dummer, Ontario K0A 3L0</li>
              <li>(705)652-3520</li>
              <li> admin@drawerinsertdesigner.com</li>
            </ul>
          </div>
        </div>
      </Modal>
      <Modal trigger={shareInsertModal} closeCallback={() => setShareKey(null)}>
        <div className="common-modal">
          <div className="common-modal__content content">
            <h2>Share your drawer insert design</h2>
            <div
              className={
                !shareKey
                  ? "is-hidden"
                  : "is-flex is-align-items-center is-flex-direction-column"
              }
            >
              <p className="is-size-5 mb-2">Link for your shared insert:</p>
              <div className="sharable-link-wrapper">
                <p id="sharedInsertLink">{`${window?.location.origin}?shared_insert=${shareKey}`}</p>
                <button
                  className="reset-button"
                  onClick={() => {
                    let el = document.getElementById("sharedInsertLink");
                    navigator.clipboard.writeText(el.innerText).then(() => {
                      notify("Copied to clipboard!");
                    });
                  }}
                >
                  Copy
                </button>
              </div>
            </div>

            <div
              className={
                shareKey
                  ? "is-hidden"
                  : "is-flex is-align-items-center is-flex-direction-column"
              }
            >
              <p>
                Click "Share" below to get a sharable link for your drawer
                insert design.
              </p>

              <button
                className="button is-success"
                onClick={() => {
                  saveSharedInsert();
                }}
              >
                Share
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal trigger={templatesModalOpen} options={{ wide: true }}>
        <div className="common-modal">
          <div className="common-modal__content p-5" style={{ width: "100%" }}>
            {selectedWidthCategory && (
              <>
                <h2 className="title is-4 has-text-centered">
                  {templateMapper[selectedWidthCategory].name} Templates
                </h2>
                <p className="mb-4 has-text-centered">
                  Select a template as a starting point for your custom wood
                  drawer organizer. You will need to fine tune the size and
                  spacing to fit your measurements.
                </p>

                <div
                  className="template-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gridTemplateRows: "repeat(2, auto)",
                    gap: "1.5rem",
                  }}
                >
                  {templateMapper[selectedWidthCategory].items.map(
                    (template, index) => {
                      return (
                        <div
                          key={index}
                          className="template-item"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleTemplateSelect(template.storageLocation)
                          }
                          onMouseEnter={(e) => {
                            const imgElement =
                              e.currentTarget.querySelector("img");
                            if (imgElement && template.imageSide) {
                              imgElement.src =
                                require(`../assets/templates/${template.imageSide}`).default;
                            }
                          }}
                          onMouseLeave={(e) => {
                            const imgElement =
                              e.currentTarget.querySelector("img");
                            if (imgElement) {
                              imgElement.src =
                                require(`../assets/templates/${template.image}`).default;
                            }
                          }}
                        >
                          <div
                            className="template-image"
                            style={{
                              position: "relative",
                              height:
                                "300px" /* Fixed height for image container */,
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                require(`../assets/templates/${template.image}`)
                                  .default
                              }
                              alt={template.name}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                borderRadius: "4px",
                                objectFit: "contain",
                                transition: "opacity 0.3s ease",
                              }}
                            />
                          </div>
                          <div
                            className="template-name has-text-centered"
                            style={{ minHeight: "40px" }}
                          >
                            <strong>{template.name}</strong>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>
      {showTour && <GuidedTour onClose={() => setShowTour(false)} />}
    </>
  );
};

export default Header;
